module.exports = __webpack_public_path__ + "static/img/backgroudg.7c2bc4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/backgroudg.png
// module id = 973
// module chunks = 41